<template>
  <div>
    <div class="page-title">主頁 Home</div>
    <el-card class="box-card">
      <div class="home-title">入學申請 Application for Admission</div>
      <el-table :data="eventStatus" style="width: 100%;">
        <el-table-column prop="title" label="Application Form 申請表">
          <template slot-scope="{ row }">
            <div style="word-break:keep-all;">{{ row.title }}</div>
          </template>
        </el-table-column>
        <el-table-column label="Application Period 申請時間">
          <template slot-scope="{ row }">
            <span>{{ row.startDate | formatDate }}</span
            >至<span>{{ row.endDate | formatDate }}</span>
          </template>
        </el-table-column>
        <el-table-column label="Action 動作">
          <template slot-scope="{ row }">
            <span
              @click="onNewAdmission(row.id, row.type)"
              class="action-link cursor"
              >Apply Now 提交申請</span
            >
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <div class="copyright-card">
      <copyrightCard></copyrightCard>
    </div>
  </div>
</template>

<script>
import { getEventStatus } from "@/api/parent/eventStatus";
import copyrightCard from "@/components/copyrightCard";
export default {
  components: { copyrightCard },
  data() {
    return {
      eventStatus: [],
    };
  },
  created() {
    this.getEventStatus();
  },
  methods: {
    onNewAdmission(eventStatusId, eventType) {
      let formType = eventType;
      this.$router.push({
        path: `/parent/application/${eventStatusId}/${formType}/add`,
      });
    },
    getEventStatus() {
      getEventStatus().then((v) => {
        this.eventStatus = v.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.home-title {
  color: #337ab7;
  font-weight: bold;
  font-size: 25px;
  margin-bottom: 30px;
}
.box-card {
  margin-bottom: 30px;
}
.copyright-card {
  background-color: #fff;
}
</style>